// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigator_H1qzx {
  background: white;
  /* border: 1px solid #e5e7eb; */
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header_oFUb8 {
  padding: 2px 4px 4px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
}

/* Project Selector */
.projectSelector_Ck3ap {
  margin-bottom: 0px;
  display: inline-flex;
  /* flex-direction: column; */
  gap: 2px;
}

.projectSelectorContent_Rf5xp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
}

/* .projectTitle {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
} */

.projectSelect_gcFta {
  width: 100%;
  padding: 8px 3px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.projectSelect_gcFta:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.projectSelect_gcFta:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.projectDescription_tEHUU {
  font-size: 9px;
  color: #6b7280;
  line-height: 22px;
  margin-right: 4px !important;
  text-align: left;
  border-top: 1px solid #ededed;
  padding: 0px 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loading_alE2u {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.tree_OrNEl {
  flex: 1 1;
  overflow-y: auto;
  padding: 2px;
}

.treeItem_XCWdW {
  margin-bottom: 0.25rem;
}

.folderItem_Ipnng,
.fileItem_iQqU_ {
  display: flex;
  align-items: center;
  padding: 2px 2px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  -webkit-user-select: none;
  user-select: none;
}

.folderItem_Ipnng:hover,
.fileItem_iQqU_:hover {
  background-color: #f3f4f6;
}

.fileItem_iQqU_.selected_PY_9K {
  background-color: #dbeafe;
  color: #1e40af;
}

.folderHeader_Dbi1u {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.folderToggle_QbObO {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  padding: 0px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.folderToggle_QbObO:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.folderToggle_QbObO:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.itemName_xjkqN {
  font-size: 12px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemActions_cxjmv {
  width: 0px;
  display: flex;
  gap: 0.25rem;
  opacity: 0;
  
  transition: opacity 0.2s ease;
}

.folderItem_Ipnng:hover .itemActions_cxjmv,
.fileItem_iQqU_:hover .itemActions_cxjmv {
  opacity: 1;
}

.actionButton_DeIWz {
  width: 24px;
  height: 24px;
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  transition: all 0.2s ease;
}

.actionButton_DeIWz:hover:not(:disabled) {
  background: #e5e7eb;
  color: #374151;
  transform: scale(1.05);
}

.actionButton_DeIWz:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fileIcon_anisu {
  font-size: 12px;
  margin-right: 4px;
}

.folderContent_nB611 {
  margin-left: 4px;
  border-left: 1px solid #e5e7eb;
  padding-left: 4px;
}

.renameInput_j_H3i {
  flex: 1 1;
  padding: 0.25rem 0.5rem;
  border: none;
  /* border-radius: 0.25rem; */

  font-size: 0.875rem;
  background: transparent;
}

.renameInput_j_H3i:focus {
  outline: none;
  /* border-color: #667eea; */
  /* box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1); */
}

.dragging_jgY4p {
  opacity: 0.5;
}

.dragOver_OVDGk {
  background-color: #dbeafe;
  border: 2px dashed #3b82f6;
}

/* Estilos para carpetas vacías */
.emptyFolder_O0Zkv {
  padding: 0.5rem;
  margin: 0.25rem 0;
  background-color: #f8fafc;
  border: 1px dashed #d1d5db;
  border-radius: 0.375rem;
  text-align: center;
}

.emptyFolderText_L1MZK {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  font-style: italic;
}

.createFileButton_yCutr {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.createFileButton_yCutr:hover {
  background-color: #2563eb;
}

/* Responsive */
@media (max-width: 768px) {
  .header_oFUb8 {
    padding: 0.75rem;
  }

  .tree_OrNEl {
    padding: 0.25rem;
  }

  .folderContent_nB611 {
    margin-left: 1rem;
    padding-left: 0.5rem;
  }

  .itemActions_cxjmv {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/FolderNavigator.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,6DAA6D;EAC7D,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;;;;GAKG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,UAAU;;EAEV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;;EAE5B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".navigator {\n  background: white;\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 8px;\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.header {\n  padding: 2px 4px 4px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Project Selector */\n.projectSelector {\n  margin-bottom: 0px;\n  display: inline-flex;\n  /* flex-direction: column; */\n  gap: 2px;\n}\n\n.projectSelectorContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2px;\n}\n\n/* .projectTitle {\n  margin: 0 0 0.75rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n} */\n\n.projectSelect {\n  width: 100%;\n  padding: 8px 3px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.projectSelect:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.projectSelect:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.projectDescription {\n  font-size: 9px;\n  color: #6b7280;\n  line-height: 22px;\n  margin-right: 4px !important;\n  text-align: left;\n  border-top: 1px solid #ededed;\n  padding: 0px 6px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.tree {\n  flex: 1;\n  overflow-y: auto;\n  padding: 2px;\n}\n\n.treeItem {\n  margin-bottom: 0.25rem;\n}\n\n.folderItem,\n.fileItem {\n  display: flex;\n  align-items: center;\n  padding: 2px 2px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.folderItem:hover,\n.fileItem:hover {\n  background-color: #f3f4f6;\n}\n\n.fileItem.selected {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.folderHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.folderToggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0px;\n  border-radius: 6px;\n  transition: background-color 0.2s ease;\n}\n\n.folderToggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.folderToggle:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.itemName {\n  font-size: 12px;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.itemActions {\n  width: 0px;\n  display: flex;\n  gap: 0.25rem;\n  opacity: 0;\n  \n  transition: opacity 0.2s ease;\n}\n\n.folderItem:hover .itemActions,\n.fileItem:hover .itemActions {\n  opacity: 1;\n}\n\n.actionButton {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #f3f4f6;\n  color: #6b7280;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  transition: all 0.2s ease;\n}\n\n.actionButton:hover:not(:disabled) {\n  background: #e5e7eb;\n  color: #374151;\n  transform: scale(1.05);\n}\n\n.actionButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.fileIcon {\n  font-size: 12px;\n  margin-right: 4px;\n}\n\n.folderContent {\n  margin-left: 4px;\n  border-left: 1px solid #e5e7eb;\n  padding-left: 4px;\n}\n\n.renameInput {\n  flex: 1;\n  padding: 0.25rem 0.5rem;\n  border: none;\n  /* border-radius: 0.25rem; */\n\n  font-size: 0.875rem;\n  background: transparent;\n}\n\n.renameInput:focus {\n  outline: none;\n  /* border-color: #667eea; */\n  /* box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1); */\n}\n\n.dragging {\n  opacity: 0.5;\n}\n\n.dragOver {\n  background-color: #dbeafe;\n  border: 2px dashed #3b82f6;\n}\n\n/* Estilos para carpetas vacías */\n.emptyFolder {\n  padding: 0.5rem;\n  margin: 0.25rem 0;\n  background-color: #f8fafc;\n  border: 1px dashed #d1d5db;\n  border-radius: 0.375rem;\n  text-align: center;\n}\n\n.emptyFolderText {\n  display: block;\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n  font-style: italic;\n}\n\n.createFileButton {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.createFileButton:hover {\n  background-color: #2563eb;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .header {\n    padding: 0.75rem;\n  }\n\n  .tree {\n    padding: 0.25rem;\n  }\n\n  .folderContent {\n    margin-left: 1rem;\n    padding-left: 0.5rem;\n  }\n\n  .itemActions {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigator": `navigator_H1qzx`,
	"header": `header_oFUb8`,
	"projectSelector": `projectSelector_Ck3ap`,
	"projectSelectorContent": `projectSelectorContent_Rf5xp`,
	"projectSelect": `projectSelect_gcFta`,
	"projectDescription": `projectDescription_tEHUU`,
	"loading": `loading_alE2u`,
	"tree": `tree_OrNEl`,
	"treeItem": `treeItem_XCWdW`,
	"folderItem": `folderItem_Ipnng`,
	"fileItem": `fileItem_iQqU_`,
	"selected": `selected_PY_9K`,
	"folderHeader": `folderHeader_Dbi1u`,
	"folderToggle": `folderToggle_QbObO`,
	"itemName": `itemName_xjkqN`,
	"itemActions": `itemActions_cxjmv`,
	"actionButton": `actionButton_DeIWz`,
	"fileIcon": `fileIcon_anisu`,
	"folderContent": `folderContent_nB611`,
	"renameInput": `renameInput_j_H3i`,
	"dragging": `dragging_jgY4p`,
	"dragOver": `dragOver_OVDGk`,
	"emptyFolder": `emptyFolder_O0Zkv`,
	"emptyFolderText": `emptyFolderText_L1MZK`,
	"createFileButton": `createFileButton_yCutr`
};
export default ___CSS_LOADER_EXPORT___;
